import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app-components/page/common/CldImageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app-components/page/home/ClientSwiperSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app-components/page/newsletter/NewsletterCardForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/resources/calculator.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/resources/codes.svg");
